import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  deletePhone,
  fetchPhoneList,
  addPhone,
  updatePhone,
  updatePhoneClient,
} from "../../apis/phone";

import type { PhoneResponce } from "../../utils/types/type-helper";


export const fetchPhoneListData = createAsyncThunk(
  "phoneList/fetchPhoneList",
  async (_, { rejectWithValue }) => {
    try {
      const phoneList = await fetchPhoneList();
      return phoneList.data; // No type enforcement
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.phoneList.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const deletePhoneById = createAsyncThunk(
  "phone/DeletePhone",
  async (
    {
      phone_id,
    }: {
      phone_id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await deletePhone(phone_id);
      return phone_id; // No type enforcement
    } catch (error: any) {
      console.log("Error in deleting phone:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const addPhoneData = createAsyncThunk(
  "phone/addPhone",
  async (partialData: PhoneResponce, { rejectWithValue }) => {
    // Changed `Phone` to `any`
    try {
      const newPhone = await addPhone(partialData);
      console.log("data", newPhone);
      const data = await newPhone;
      return data; // No type enforcement
    } catch (error: any) {
      console.log("Error in adding phone:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const updatePhoneData = createAsyncThunk(
  "phone/updatePhone",
  async (
    {
      phone_id,
      data,
    }: {
      phone_id: string;
      data: {
        [key: string]: any;
        phone_id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await updatePhone(phone_id, data);
      return response.data;
    } catch (error: any) {
      console.log("Error in adding phone:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const updatePhoneClientData = createAsyncThunk(
  "phone/updatePhoneClient",
  async (
    {
      phoneId,
      clientId,
      oldClientId,
    }: {
      phoneId: string;
      clientId: string;
      oldClientId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await updatePhoneClient(phoneId, clientId, oldClientId);
      return response.data;
    } catch (error: any) {
      console.log("Error in updating phone client:", error);
      return rejectWithValue(error.message);
    }
  }
);
